import { getFromWebAPi } from '@/services/messaging/fetchQuery';


export function getBaseProductDetailsByProductId(productId, includeCustomerDetailsWhenAvailable, isConsignmentProduct) {
  return getFromWebAPi("Products/GetRegular?productId=" + productId + "&includeCustomerDetailsWhenAvailable=" + (includeCustomerDetailsWhenAvailable?"true":"false") + "&isConsignmentProduct=" + isConsignmentProduct);
}
